<!-- Sales Report -->
<div class="sales-report-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-main">
        <div class="header-icon">
          <i class="fas fa-chart-line"></i>
        </div>
        <div class="header-text">
          <h1 class="page-title">Sales Report</h1>
          <p class="page-description">Comprehensive sales analytics and performance tracking</p>
        </div>
      </div>
      <div class="header-actions">
        <button class="btn btn-outline-secondary" (click)="getSalesSummary(); getTopSummary(); getWaiterPerformance(); getSalesHistory()">
          <i class="fas fa-sync-alt me-1" [class.fa-spin]="isLoading"></i>
          Refresh
        </button>
        <button class="btn btn-primary" (click)="exportToExcel()" [disabled]="isExporting">
          <span *ngIf="!isExporting">
            <i class="fas fa-file-excel me-1"></i>Export
          </span>
          <span *ngIf="isExporting">
            <i class="fas fa-spinner fa-spin me-1"></i>Exporting...
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Navigation Tabs -->
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav nav-pills mb-4" style="gap: 6px;">
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <i class="fas fa-chart-bar me-2"></i>Sales Summary
      </a>
      <ng-template ngbNavContent>
        <!-- KPI Summary Cards -->
        <div class="row g-3 mb-4">
          <div class="col-xl-4 col-md-6" *ngFor="let summary of summaryCards; let i = index">
            <div class="kpi-card" style="background: var(--card-bg); border: 1px solid var(--card-border); border-radius: var(--radius-lg); padding: 20px; box-shadow: var(--card-shadow);">
              <div class="d-flex align-items-start justify-content-between mb-3">
                <div style="width: 42px; height: 42px; border-radius: var(--radius-md); display: flex; align-items: center; justify-content: center; font-size: 16px;"
                     [ngStyle]="{
                       'background': i === 0 ? 'var(--accent-subtle)' : i === 1 ? 'var(--danger-bg)' : 'var(--success-bg)',
                       'color': i === 0 ? 'var(--accent)' : i === 1 ? 'var(--danger-text)' : 'var(--success-text)'
                     }">
                  <i [class]="getKpiIcon(summary.title)"></i>
                </div>
                <div ngbDropdown class="dropdown">
                  <button class="btn btn-link p-0" type="button" ngbDropdownToggle style="color: var(--text-tertiary); font-size: 14px;">
                    <i class="fas fa-ellipsis-h"></i>
                  </button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem>Today</button>
                    <button ngbDropdownItem>This Week</button>
                    <button ngbDropdownItem>This Month</button>
                  </div>
                </div>
              </div>
              <div>
                <div style="font-size: 12px; font-weight: 500; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 6px;">{{summary.title}}</div>
                <div *ngIf="!isLoadingSummary" style="font-size: 24px; font-weight: 700; color: var(--text-primary); line-height: 1.2;">
                  <span *ngIf="summary.title !== 'Total Sales'; else totalSalesTemplate">
                    ₦{{summary.value | number:'1.2-2'}}
                  </span>
                  <ng-template #totalSalesTemplate>
                    {{summary.value | number:'1.0-0'}}
                  </ng-template>
                </div>
                <div *ngIf="isLoadingSummary">
                  <div class="loading-shimmer" style="height: 32px; width: 140px; border-radius: 6px;"></div>
                </div>
                <div *ngIf="!isLoadingSummary" style="margin-top: 10px; display: flex; align-items: center; gap: 6px;">
                  <span class="badge badge-success badge-sm" style="font-size: 11px;">
                    <i class="fas fa-arrow-up me-1" style="font-size: 9px;"></i>2.5%
                  </span>
                  <span style="font-size: 12px; color: var(--text-tertiary);">vs last period</span>
                </div>
                <div *ngIf="isLoadingSummary" style="margin-top: 10px;">
                  <div class="loading-shimmer" style="height: 14px; width: 100px; border-radius: 4px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Analytics Cards Row -->
        <div class="row g-3 mb-4">
          <!-- Top Selling Items -->
          <div class="col-xl-4 col-lg-6">
            <div class="data-panel" style="height: 100%;">
              <div class="panel-header">
                <div class="panel-title">
                  <div class="title-icon"><i class="fas fa-trophy"></i></div>
                  <div>
                    <div class="title-text">Top Selling Items</div>
                    <div class="title-subtitle">Most popular menu items</div>
                  </div>
                </div>
                <div ngbDropdown>
                  <button class="btn btn-link btn-sm p-0" type="button" ngbDropdownToggle style="color: var(--text-tertiary); text-decoration: none; font-size: 12px;">
                    Today <i class="fas fa-chevron-down ms-1"></i>
                  </button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem>This Week</button>
                    <button ngbDropdownItem>This Month</button>
                  </div>
                </div>
              </div>
              <div class="panel-body" style="padding: 16px 20px;">
                <div *ngIf="!isLoadingTopData">
                  <div *ngFor="let item of topSellingItems" style="display: flex; align-items: center; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid var(--border-subtle);">
                    <div>
                      <div style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{item.name}}</div>
                      <div style="font-size: 12px; color: var(--text-tertiary);">{{item.item_count}} orders</div>
                    </div>
                    <div style="width: 100px; height: 6px; background: var(--bg-muted); border-radius: 3px; overflow: hidden;">
                      <div style="height: 100%; background: var(--accent); border-radius: 3px; transition: width 0.3s ease;" [style.width.%]="(item.item_count / maxTopSellingValue) * 100"></div>
                    </div>
                  </div>
                  <div *ngIf="topSellingItems.length === 0" class="empty-state" style="padding: 30px 10px;">
                    <div class="empty-icon"><i class="fas fa-chart-bar" style="font-size: 28px;"></i></div>
                    <p style="font-size: 13px; color: var(--text-tertiary); margin: 0;">No data available</p>
                  </div>
                </div>
                <div *ngIf="isLoadingTopData">
                  <div *ngFor="let i of [1,2,3]" style="display: flex; align-items: center; justify-content: space-between; padding: 12px 0;">
                    <div>
                      <div class="loading-shimmer" style="height: 14px; width: 110px; border-radius: 4px; margin-bottom: 6px;"></div>
                      <div class="loading-shimmer" style="height: 11px; width: 70px; border-radius: 4px;"></div>
                    </div>
                    <div class="loading-shimmer" style="height: 6px; width: 80px; border-radius: 3px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Top Categories -->
          <div class="col-xl-4 col-lg-6">
            <div class="data-panel" style="height: 100%;">
              <div class="panel-header">
                <div class="panel-title">
                  <div class="title-icon"><i class="fas fa-layer-group"></i></div>
                  <div>
                    <div class="title-text">Top Categories</div>
                    <div class="title-subtitle">Best performing categories</div>
                  </div>
                </div>
                <div ngbDropdown>
                  <button class="btn btn-link btn-sm p-0" type="button" ngbDropdownToggle style="color: var(--text-tertiary); text-decoration: none; font-size: 12px;">
                    Today <i class="fas fa-chevron-down ms-1"></i>
                  </button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem>This Week</button>
                    <button ngbDropdownItem>This Month</button>
                  </div>
                </div>
              </div>
              <div class="panel-body" style="padding: 16px 20px;">
                <div *ngIf="!isLoadingTopData">
                  <div *ngFor="let category of topCategories" style="display: flex; align-items: center; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid var(--border-subtle);">
                    <div>
                      <div style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{category.name}}</div>
                      <div style="font-size: 12px; color: var(--text-tertiary);">{{category.category_count}} orders</div>
                    </div>
                    <div style="width: 100px; height: 6px; background: var(--bg-muted); border-radius: 3px; overflow: hidden;">
                      <div style="height: 100%; background: var(--info-text); border-radius: 3px; transition: width 0.3s ease;" [style.width.%]="(category.category_count / maxTopCategoryValue) * 100"></div>
                    </div>
                  </div>
                  <div *ngIf="topCategories.length === 0" class="empty-state" style="padding: 30px 10px;">
                    <div class="empty-icon"><i class="fas fa-layer-group" style="font-size: 28px;"></i></div>
                    <p style="font-size: 13px; color: var(--text-tertiary); margin: 0;">No data available</p>
                  </div>
                </div>
                <div *ngIf="isLoadingTopData">
                  <div *ngFor="let i of [1,2,3]" style="display: flex; align-items: center; justify-content: space-between; padding: 12px 0;">
                    <div>
                      <div class="loading-shimmer" style="height: 14px; width: 100px; border-radius: 4px; margin-bottom: 6px;"></div>
                      <div class="loading-shimmer" style="height: 11px; width: 65px; border-radius: 4px;"></div>
                    </div>
                    <div class="loading-shimmer" style="height: 6px; width: 80px; border-radius: 3px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Payment Methods Chart -->
          <div class="col-xl-4 col-lg-12">
            <div class="data-panel" style="height: 100%;">
              <div class="panel-header">
                <div class="panel-title">
                  <div class="title-icon"><i class="fas fa-credit-card"></i></div>
                  <div>
                    <div class="title-text">Payment Methods</div>
                    <div class="title-subtitle">Payment distribution</div>
                  </div>
                </div>
                <div ngbDropdown>
                  <button class="btn btn-link btn-sm p-0" type="button" ngbDropdownToggle style="color: var(--text-tertiary); text-decoration: none; font-size: 12px;">
                    Today <i class="fas fa-chevron-down ms-1"></i>
                  </button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem>This Week</button>
                    <button ngbDropdownItem>This Month</button>
                  </div>
                </div>
              </div>
              <div class="panel-body" style="padding: 16px 20px;">
                <div *ngIf="!isLoadingTopData">
                  <div style="display: flex; justify-content: center; margin-bottom: 16px;">
                    <div style="width: 180px; height: 180px;">
                      <canvas baseChart #paymentMethodsChart [data]="pieChartData" [type]="pieChartType"
                        [options]="pieChartOptions">
                      </canvas>
                    </div>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 8px;">
                    <div *ngFor="let method of paymentMethods" style="display: flex; align-items: center; gap: 10px; font-size: 13px;">
                      <span style="width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0;"
                        [style.backgroundColor]="paymentMethodColors[method.payment_method]"></span>
                      <span style="color: var(--text-secondary);">{{formatPaymentMethodName(method.payment_method)}} ({{method.percentage}}%)</span>
                    </div>
                  </div>
                </div>
                <div *ngIf="isLoadingTopData">
                  <div style="display: flex; justify-content: center; margin-bottom: 16px;">
                    <div class="loading-shimmer" style="height: 180px; width: 180px; border-radius: 50%;"></div>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 8px;">
                    <div *ngFor="let i of [1,2,3]" style="display: flex; align-items: center; gap: 10px;">
                      <div class="loading-shimmer" style="height: 10px; width: 10px; border-radius: 50%;"></div>
                      <div class="loading-shimmer" style="height: 12px; width: 100px; border-radius: 4px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Employee Sales Performance Table -->
        <div class="data-panel">
          <div class="panel-header">
            <div class="panel-title">
              <div class="title-icon"><i class="fas fa-users"></i></div>
              <div>
                <div class="title-text">Employee Sales Performance</div>
                <div class="title-subtitle">Track individual waiter performance and sales metrics</div>
              </div>
            </div>
            <div class="panel-info">
              <span class="info-item" style="font-size: 12px; color: var(--text-tertiary);">
                <span class="info-value" style="font-weight: 600; color: var(--text-secondary);">{{employeeSales.length}}</span> employees
              </span>
            </div>
          </div>
          <div class="panel-body table-container">
            <table class="table">
              <thead>
                <tr>
                  <th>Waiter</th>
                  <th>Total Orders</th>
                  <th>Sales Amount</th>
                  <th>Average Order</th>
                  <th>Rating</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let employee of employeeSales" [hidden]="isLoadingEmployeeData">
                  <td>
                    <div style="display: flex; align-items: center; gap: 10px;">
                      <div style="width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 600; color: #fff; flex-shrink: 0; background-size: cover; background-position: center;"
                           [style.backgroundImage]="employee.waiter_image ? 'url(' + employee.waiter_image + ')' : ''"
                           [style.backgroundColor]="!employee.waiter_image ? '#667eea' : ''">
                        <span *ngIf="!employee.waiter_image">{{employee.waiter_name.charAt(0)}}</span>
                      </div>
                      <div>
                        <div style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{employee.waiter_name}}</div>
                        <div style="font-size: 11px; color: var(--text-tertiary);">Waiter</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="badge badge-light">{{employee.total_orders_handled}}</span>
                  </td>
                  <td>
                    <span style="font-weight: 600; color: var(--text-primary);">{{employee.total_sales_amount | currency:'₦':'symbol':'1.2-2'}}</span>
                  </td>
                  <td>
                    <span style="color: var(--text-secondary);">{{employee.average_order_value || 0 | currency:'₦':'symbol':'1.2-2'}}</span>
                  </td>
                  <td>
                    <span *ngIf="employee.average_customer_rating; else noRating" style="display: flex; align-items: center; gap: 4px;">
                      <i class="fas fa-star" style="color: #f59e0b; font-size: 12px;"></i>
                      <span style="font-weight: 500;">{{employee.average_customer_rating | number:'1.1-1'}}</span>
                    </span>
                    <ng-template #noRating>
                      <span style="font-size: 12px; color: var(--text-tertiary);">No ratings</span>
                    </ng-template>
                  </td>
                </tr>
                <!-- Loading Shimmer Rows -->
                <tr *ngFor="let i of [1,2,3,4,5]" [hidden]="!isLoadingEmployeeData">
                  <td>
                    <div style="display: flex; align-items: center; gap: 10px;">
                      <div class="loading-shimmer" style="height: 36px; width: 36px; border-radius: 50%;"></div>
                      <div>
                        <div class="loading-shimmer" style="height: 14px; width: 110px; border-radius: 4px; margin-bottom: 4px;"></div>
                        <div class="loading-shimmer" style="height: 10px; width: 50px; border-radius: 4px;"></div>
                      </div>
                    </div>
                  </td>
                  <td><div class="loading-shimmer" style="height: 14px; width: 36px; border-radius: 4px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 14px; width: 80px; border-radius: 4px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 14px; width: 80px; border-radius: 4px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 14px; width: 50px; border-radius: 4px;"></div></td>
                </tr>
                <!-- Empty State -->
                <tr *ngIf="employeeSales.length === 0 && !isLoadingEmployeeData">
                  <td colspan="5">
                    <div class="empty-state">
                      <div class="empty-icon"><i class="fas fa-users" style="font-size: 32px;"></i></div>
                      <h5 class="empty-title">No employee data available</h5>
                      <p class="empty-subtitle">Employee sales data will appear here once available.</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="panel-footer" *ngIf="size > pageSize">
            <div class="pagination-info">
              Showing {{((page - 1) * pageSize) + 1}} to {{page * pageSize > size ? size : page * pageSize}} of {{size}}
            </div>
            <ngb-pagination
              [collectionSize]="size"
              [(page)]="page"
              [pageSize]="pageSize"
              [maxSize]="5"
              [rotate]="true"
              [ellipses]="false"
              [boundaryLinks]="true"
              (pageChange)="refresh($event)">
            </ngb-pagination>
          </div>
        </div>
      </ng-template>
    </li>

    <li [ngbNavItem]="2">
      <a ngbNavLink>
        <i class="fas fa-history me-2"></i>Sales History
      </a>
      <ng-template ngbNavContent>
        <!-- Filters Panel -->
        <div class="filters-panel">
          <div class="search-section" style="margin-bottom: 16px;">
            <div class="search-box">
              <div class="search-input-wrapper">
                <i class="fas fa-search search-icon"></i>
                <input type="text"
                       class="search-input"
                       placeholder="Search by order ID, status, or payment method..."
                       [(ngModel)]="searchTerm"
                       (input)="onSearch()"
                       style="padding-left: 38px;">
              </div>
            </div>
          </div>

          <div class="filters-section">
            <div class="filter-group">
              <!-- Date Range Filter -->
              <div style="display: flex; flex-direction: column; gap: 8px;">
                <label style="font-size: 12px; font-weight: 600; color: var(--text-secondary); display: flex; align-items: center; gap: 6px;">
                  <i class="fas fa-calendar-alt" style="font-size: 12px;"></i>Date Range
                </label>
                <div style="display: flex; gap: 6px; flex-wrap: wrap;">
                  <button class="btn btn-sm" [class.btn-primary]="selectedDateFilter === 'today'" [class.btn-tertiary]="selectedDateFilter !== 'today'" (click)="setDateRange('today')">Today</button>
                  <button class="btn btn-sm" [class.btn-primary]="selectedDateFilter === 'week'" [class.btn-tertiary]="selectedDateFilter !== 'week'" (click)="setDateRange('week')">This Week</button>
                  <button class="btn btn-sm" [class.btn-primary]="selectedDateFilter === 'month'" [class.btn-tertiary]="selectedDateFilter !== 'month'" (click)="setDateRange('month')">This Month</button>
                  <button class="btn btn-sm" [class.btn-primary]="showDatePicker" [class.btn-tertiary]="!showDatePicker" (click)="showDatePicker = !showDatePicker">
                    <i class="fas fa-calendar-alt me-1"></i>Custom
                  </button>
                </div>
              </div>

              <!-- Payment Method Dropdown -->
              <div style="display: flex; flex-direction: column; gap: 8px;">
                <label style="font-size: 12px; font-weight: 600; color: var(--text-secondary); display: flex; align-items: center; gap: 6px;">
                  <i class="fas fa-credit-card" style="font-size: 12px;"></i>Payment Method
                </label>
                <div ngbDropdown class="dropdown">
                  <button class="btn btn-outline-secondary btn-sm" ngbDropdownToggle>
                    <i class="fas fa-filter me-1"></i>
                    {{selectedPaymentMethod || 'All Payment Methods'}}
                  </button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem (click)="onPaymentMethodFilter('')">All Methods</button>
                    <button ngbDropdownItem (click)="onPaymentMethodFilter('cash')">
                      <i class="fas fa-money-bill-wave me-2" style="color: #53B1FD;"></i>Cash
                    </button>
                    <button ngbDropdownItem (click)="onPaymentMethodFilter('pos')">
                      <i class="fas fa-credit-card me-2" style="color: #F2994A;"></i>Card (POS)
                    </button>
                    <button ngbDropdownItem (click)="onPaymentMethodFilter('transfer')">
                      <i class="fas fa-university me-2" style="color: #7F56D9;"></i>Transfer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Custom Date Picker -->
          <div *ngIf="showDatePicker" style="margin-top: 12px; padding-top: 12px; border-top: 1px solid var(--border-subtle);">
            <div class="row g-3">
              <div class="col-md-5">
                <label class="form-label">Start Date</label>
                <input type="date" class="form-control" #startDate>
              </div>
              <div class="col-md-5">
                <label class="form-label">End Date</label>
                <input type="date" class="form-control" #endDate>
              </div>
              <div class="col-md-2">
                <label class="form-label">&nbsp;</label>
                <button class="btn btn-primary d-block w-100"
                        (click)="onCustomDateSelect(startDate.value, endDate.value)">
                  Apply
                </button>
              </div>
            </div>
          </div>

          <!-- Active Filter Tags -->
          <div *ngIf="selectedDateFilter || selectedPaymentMethod" style="margin-top: 12px; display: flex; gap: 8px; flex-wrap: wrap; align-items: center;">
            <span style="font-size: 12px; color: var(--text-tertiary);">Active filters:</span>
            <span *ngIf="selectedDateFilter" class="badge badge-light" style="display: inline-flex; align-items: center; gap: 4px;">
              <i class="fas fa-calendar-alt" style="font-size: 10px;"></i>
              {{selectedDateFilter | titlecase}}
            </span>
            <span *ngIf="selectedPaymentMethod" class="badge badge-light" style="display: inline-flex; align-items: center; gap: 4px;">
              <i class="fas fa-credit-card" style="font-size: 10px;"></i>
              {{selectedPaymentMethod | titlecase}}
            </span>
          </div>
        </div>

        <!-- Sales History Table -->
        <div class="data-panel">
          <div class="panel-header">
            <div class="panel-title">
              <div class="title-icon"><i class="fas fa-receipt"></i></div>
              <div>
                <div class="title-text">Sales History</div>
                <div class="title-subtitle">Complete transaction history and order details</div>
              </div>
            </div>
            <div class="panel-info">
              <span class="info-item" style="font-size: 12px; color: var(--text-tertiary);">
                <span class="info-value" style="font-weight: 600; color: var(--text-secondary);">{{filteredsalesHistory.length}}</span> records
              </span>
            </div>
          </div>
          <div class="panel-body table-container">
            <table class="table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Amount</th>
                  <th>DOTA Charges</th>
                  <th>Payment Method</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th style="width: 60px;">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!-- Data Rows -->
                <tr *ngFor="let item of filteredsalesHistory" [hidden]="isLoadingHistory">
                  <td>
                    <span style="font-weight: 500; color: var(--accent); font-size: 13px;">{{item.order_uid}}</span>
                  </td>
                  <td>
                    <span style="font-weight: 600; color: var(--text-primary);">₦{{item.order_amount | number:'1.2-2'}}</span>
                  </td>
                  <td>
                    <span style="color: var(--text-secondary);">₦{{item.commercial_dota | number:'1.2-2'}}</span>
                  </td>
                  <td>
                    <div style="display: flex; gap: 4px; flex-wrap: wrap;">
                      <span *ngFor="let method of item.payment_method"
                            class="badge"
                            [ngClass]="getPaymentMethodClass(method)"
                            style="font-size: 11px; font-weight: 500;">
                        {{method | titlecase}}
                      </span>
                    </div>
                  </td>
                  <td>
                    <span class="badge badge-dot" [ngClass]="getStatusClass(item.status)">
                      {{item.status | titlecase}}
                    </span>
                  </td>
                  <td>
                    <div>
                      <div style="font-size: 13px; color: var(--text-primary);">{{item.transaction_date | date:'MMM dd, yyyy'}}</div>
                      <div style="font-size: 11px; color: var(--text-tertiary);">{{item.transaction_date | date:'HH:mm'}}</div>
                    </div>
                  </td>
                  <td>
                    <div ngbDropdown class="d-inline-block" container="body">
                      <button class="btn btn-sm btn-outline-secondary" ngbDropdownToggle style="padding: 4px 8px;">
                        <i class="fas fa-ellipsis-h"></i>
                      </button>
                      <div ngbDropdownMenu>
                        <button ngbDropdownItem (click)="invItem(content, item)">
                          <i class="fas fa-box me-2"></i>View Items
                        </button>
                        <button ngbDropdownItem (click)="customerInfo(content2, item)">
                          <i class="fas fa-user me-2"></i>Customer Info
                        </button>
                        <button ngbDropdownItem (click)="waiterInfo(content3, item)">
                          <i class="fas fa-user-tie me-2"></i>Waiter Info
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                <!-- Loading Shimmer Rows -->
                <tr *ngFor="let i of [1,2,3,4,5,6,7,8]" [hidden]="!isLoadingHistory">
                  <td><div class="loading-shimmer" style="height: 14px; width: 90px; border-radius: 4px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 14px; width: 80px; border-radius: 4px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 14px; width: 70px; border-radius: 4px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 22px; width: 60px; border-radius: 10px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 22px; width: 70px; border-radius: 10px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 14px; width: 100px; border-radius: 4px;"></div></td>
                  <td><div class="loading-shimmer" style="height: 28px; width: 28px; border-radius: 6px;"></div></td>
                </tr>
                <!-- Empty State -->
                <tr *ngIf="filteredsalesHistory.length === 0 && !isLoadingHistory">
                  <td colspan="7">
                    <div class="empty-state">
                      <div class="empty-icon"><i class="fas fa-receipt" style="font-size: 32px;"></i></div>
                      <h5 class="empty-title">No sales history found</h5>
                      <p class="empty-subtitle">Sales transactions will appear here once available.</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="panel-footer" *ngIf="historyTotal > historyPageSize">
            <div class="pagination-info">
              Showing {{((historyPage - 1) * historyPageSize) + 1}} to {{historyPage * historyPageSize > historyTotal ? historyTotal : historyPage * historyPageSize}} of {{historyTotal}}
            </div>
            <ngb-pagination
              [collectionSize]="historyTotal"
              [(page)]="historyPage"
              [pageSize]="historyPageSize"
              [maxSize]="5"
              [rotate]="true"
              [ellipses]="false"
              [boundaryLinks]="true"
              (pageChange)="refreshHistory($event)">
            </ngb-pagination>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>

<!-- Order Items Modal -->
<ng-template #content let-modal>
  <div class="modal-header">
    <div class="d-flex align-items-center gap-3">
      <div style="width: 36px; height: 36px; border-radius: var(--radius-md); background: var(--accent-subtle); color: var(--accent); display: flex; align-items: center; justify-content: center;">
        <i class="fas fa-box"></i>
      </div>
      <div>
        <h5 class="modal-title" style="margin: 0;">Order Items</h5>
        <p style="font-size: 12px; color: var(--text-tertiary); margin: 0;">Order: {{selectedOrder?.order_uid}}</p>
      </div>
    </div>
    <button type="button" class="btn-close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body">
    <div *ngIf="selectedOrder?.items && selectedOrder.items.length > 0; else noItems">
      <div *ngFor="let item of selectedOrder.items" style="display: flex; gap: 14px; padding: 14px; margin-bottom: 10px; border: 1px solid var(--border-subtle); border-radius: var(--radius-md); background: var(--bg-muted);">
        <div style="width: 60px; height: 60px; border-radius: var(--radius-sm); overflow: hidden; flex-shrink: 0;">
          <img [src]="item.image" [alt]="item.inventory" style="width: 100%; height: 100%; object-fit: cover;">
        </div>
        <div style="flex: 1;">
          <h6 style="margin: 0 0 6px; font-size: 14px; font-weight: 600; color: var(--text-primary);">{{item.inventory}}</h6>
          <div style="display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: 6px;">
            <span class="badge badge-soft-primary badge-sm">Qty: {{item.quantity}}</span>
            <span class="badge badge-soft-success badge-sm">₦{{item.amount | number:'1.2-2'}}</span>
            <span class="badge badge-sm" [ngClass]="item.returned ? 'badge-soft-danger' : 'badge-secondary'">
              {{item.returned ? 'Returned' : 'Active'}}
            </span>
          </div>
          <div style="font-size: 13px; font-weight: 600; color: var(--text-primary);">
            Total: ₦{{(+item.amount * item.quantity) | number:'1.2-2'}}
          </div>
          <div *ngIf="item.return_reason" style="margin-top: 6px; font-size: 12px; color: var(--danger-text);">
            <i class="fas fa-exclamation-triangle me-1"></i>
            Return Reason: {{item.return_reason}}
          </div>
        </div>
      </div>
      <div style="margin-top: 16px; padding: 14px; background: var(--bg-muted); border-radius: var(--radius-md); display: flex; justify-content: space-between; align-items: center;">
        <span style="font-weight: 600; color: var(--text-secondary);">Order Total</span>
        <span style="font-size: 18px; font-weight: 700; color: var(--accent);">₦{{selectedOrder?.order_amount | number:'1.2-2'}}</span>
      </div>
    </div>
    <ng-template #noItems>
      <div class="empty-state">
        <div class="empty-icon"><i class="fas fa-box" style="font-size: 32px;"></i></div>
        <h5 class="empty-title">No items in this order</h5>
        <p class="empty-subtitle">This order doesn't contain any items.</p>
      </div>
    </ng-template>
  </div>
</ng-template>

<!-- Customer Info Modal -->
<ng-template #content2 let-modal>
  <div class="modal-header">
    <div class="d-flex align-items-center gap-3">
      <div style="width: 36px; height: 36px; border-radius: var(--radius-md); background: var(--info-bg); color: var(--info-text); display: flex; align-items: center; justify-content: center;">
        <i class="fas fa-user"></i>
      </div>
      <div>
        <h5 class="modal-title" style="margin: 0;">Customer Information</h5>
        <p style="font-size: 12px; color: var(--text-tertiary); margin: 0;">Order: {{selectedOrder?.order_uid}}</p>
      </div>
    </div>
    <button type="button" class="btn-close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body">
    <div class="empty-state" style="padding: 30px;">
      <div class="empty-icon"><i class="fas fa-user" style="font-size: 32px;"></i></div>
      <h5 class="empty-title">Customer Information Not Available</h5>
      <p class="empty-subtitle">Customer details are not included in the current order data structure.</p>
      <div style="margin-top: 16px; padding: 14px; background: var(--bg-muted); border-radius: var(--radius-md); text-align: left;">
        <div class="row">
          <div class="col-6">
            <span style="font-size: 12px; color: var(--text-tertiary);">Order ID</span><br>
            <span style="font-weight: 500; color: var(--text-primary);">{{selectedOrder?.order_uid}}</span>
          </div>
          <div class="col-6">
            <span style="font-size: 12px; color: var(--text-tertiary);">Amount</span><br>
            <span style="font-weight: 600; color: var(--success-text);">₦{{selectedOrder?.order_amount | number:'1.2-2'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Waiter Info Modal -->
<ng-template #content3 let-modal>
  <div class="modal-header">
    <div class="d-flex align-items-center gap-3">
      <div style="width: 36px; height: 36px; border-radius: var(--radius-md); background: var(--warning-bg); color: var(--warning-text); display: flex; align-items: center; justify-content: center;">
        <i class="fas fa-user-tie"></i>
      </div>
      <div>
        <h5 class="modal-title" style="margin: 0;">Waiter Information</h5>
        <p style="font-size: 12px; color: var(--text-tertiary); margin: 0;">Order: {{selectedOrder?.order_uid}}</p>
      </div>
    </div>
    <button type="button" class="btn-close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body">
    <div *ngIf="selectedOrder?.waiter; else noWaiter">
      <!-- Waiter Profile Header -->
      <div style="text-align: center; padding: 20px 0; margin-bottom: 20px; border-bottom: 1px solid var(--border-subtle);">
        <div style="width: 72px; height: 72px; border-radius: 50%; margin: 0 auto 12px; overflow: hidden; border: 3px solid var(--border);">
          <img *ngIf="selectedOrder.waiter.image"
               [src]="selectedOrder.waiter.image"
               [alt]="selectedOrder.waiter.first_name + ' ' + selectedOrder.waiter.last_name"
               style="width: 100%; height: 100%; object-fit: cover;">
          <div *ngIf="!selectedOrder.waiter.image"
               style="width: 100%; height: 100%; background: #667eea; display: flex; align-items: center; justify-content: center;">
            <span style="font-size: 24px; font-weight: 700; color: #fff;">{{selectedOrder.waiter.first_name.charAt(0)}}{{selectedOrder.waiter.last_name.charAt(0)}}</span>
          </div>
        </div>
        <h5 style="margin: 0 0 6px; font-weight: 600;">{{selectedOrder.waiter.first_name}} {{selectedOrder.waiter.last_name}}</h5>
        <div style="display: flex; gap: 6px; justify-content: center;">
          <span class="badge badge-soft-primary badge-sm" *ngFor="let role of selectedOrder.waiter.roles">
            {{role | titlecase}}
          </span>
        </div>
      </div>

      <!-- Waiter Details -->
      <div style="display: flex; flex-direction: column; gap: 12px;">
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: var(--bg-muted); border-radius: var(--radius-md);">
          <span style="font-size: 13px; color: var(--text-tertiary); display: flex; align-items: center; gap: 8px;">
            <i class="fas fa-id-card" style="width: 16px;"></i>Employee ID
          </span>
          <span style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{selectedOrder.waiter.id}}</span>
        </div>
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: var(--bg-muted); border-radius: var(--radius-md);">
          <span style="font-size: 13px; color: var(--text-tertiary); display: flex; align-items: center; gap: 8px;">
            <i class="fas fa-phone" style="width: 16px;"></i>Phone
          </span>
          <span style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{selectedOrder.waiter.phone}}</span>
        </div>
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: var(--bg-muted); border-radius: var(--radius-md);">
          <span style="font-size: 13px; color: var(--text-tertiary); display: flex; align-items: center; gap: 8px;">
            <i class="fas fa-envelope" style="width: 16px;"></i>Email
          </span>
          <span style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{selectedOrder.waiter.email}}</span>
        </div>
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: var(--bg-muted); border-radius: var(--radius-md);">
          <span style="font-size: 13px; color: var(--text-tertiary); display: flex; align-items: center; gap: 8px;">
            <i class="fas fa-building" style="width: 16px;"></i>Tenant
          </span>
          <span style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{selectedOrder.waiter.tenant}}</span>
        </div>
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: var(--bg-muted); border-radius: var(--radius-md);">
          <span style="font-size: 13px; color: var(--text-tertiary); display: flex; align-items: center; gap: 8px;">
            <i class="fas fa-circle" style="width: 16px;"></i>Status
          </span>
          <span class="badge" [ngClass]="selectedOrder.waiter.disabled ? 'badge-soft-danger' : 'badge-soft-success'">
            {{selectedOrder.waiter.disabled ? 'Disabled' : 'Active'}}
          </span>
        </div>
      </div>
    </div>
    <ng-template #noWaiter>
      <div class="empty-state">
        <div class="empty-icon"><i class="fas fa-user-tie" style="font-size: 32px;"></i></div>
        <h5 class="empty-title">No waiter information</h5>
        <p class="empty-subtitle">Waiter information is not available for this order.</p>
      </div>
    </ng-template>
  </div>
</ng-template>
